// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL    : 'https://realplaza-cusco.mzzo.com/api/',
  // apiURL    : 'http://localhost:8000/api/',
  edificio  : 158,
  totem     : 319,
  canal     : 2,
  idioma    : 'Esp',
  timereload : 60,
  tiendaimagen : false,
  idEst : [6376], /* IDs de estacionamientos */
  colorEst : ['Naranja'], /* colores estacionamientos*/

  codCine: '0', /* id de Cine */
  patioDeComida: 997, /* id patio de comida, en caso de no haber usar 0 */
  zonaGourmet: 998, /* id zona gourmet, en caso de no haber usar 0 */

  orientacionHor : [106, 0], /* [Norte, Sur] */
  orientacionVer : [0, 0], /* [Oeste, Este] */
  tipoTransporte : {pie: 65, alternativo: 26}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
